import { EMailType } from '@leedpulse-monorepo/enums';
import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import { Authentication } from '@leedpulse-monorepo/classes';

export interface PreviewMailResponse {
  subject: string;
  html: string;
}

/**
 * The mail a manual send would deliver to the user, secrets masked. Shown before every send.
 */
async function previewMail(
  mailType: EMailType,
  userId: string,
  auth: Authentication | null,
): Promise<PreviewMailResponse> {
  try {
    if (!auth) throw new PreviewMailFailure('Vous devez être connecté pour effectuer cette action.', 'unauthorized');

    const response = await HttpClient.post(
      `/backoffice/users/${userId}/previewmail`,
      { mailType },
      auth.token
    );

    return response.data;
  } catch (e) {
    if (e instanceof PreviewMailFailure) throw e;
    const errMessage = e instanceof Error ? e.message : typeof e === 'string' ? e : '';
    throw new PreviewMailFailure(
      errMessage.trim() || 'Aperçu indisponible. Réessayez plus tard.',
      'request-failed',
    );
  }
}

export class PreviewMailFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default previewMail;
